import { IconName } from '@ardoq/icons';
import { t, type I18nLocale } from '@ardoq/i18n';
import type { AiThinkingStep } from '@ardoq/ai';
import { LoadedChat, ToolCallActionCategory } from '@ardoq/api-types';
import { groupBy, mapValues } from 'lodash';
import { isToolCallMessage } from './types';

const ACTION_CATEGORY_ICON: Record<ToolCallActionCategory, IconName> = {
  [ToolCallActionCategory.PLAN]: IconName.MY_TASKS,
  [ToolCallActionCategory.SEARCH]: IconName.SEARCH,
  [ToolCallActionCategory.LIST]: IconName.LIST,
  [ToolCallActionCategory.ANALYZE]: IconName.BAR_CHART,
  [ToolCallActionCategory.EXECUTE]: IconName.VIDEO_TUTORIALS,
  [ToolCallActionCategory.FILTER]: IconName.SEARCH,
  [ToolCallActionCategory.SUGGEST_VALUES]: IconName.SEARCH,
  [ToolCallActionCategory.AGGREGATE]: IconName.CALCULATOR,
  [ToolCallActionCategory.RESOLVE]: IconName.SEARCH,
  [ToolCallActionCategory.TRAVERSE]: IconName.ACCOUNT_TREE,
  [ToolCallActionCategory.FETCH_EXTERNAL]: IconName.ACCOUNT_TREE,
};

export const PLAN_STEP_ICON: IconName = IconName.MY_TASKS;
export const DEFAULT_STEP_ICON: IconName = IconName.SPARKLES;

export const getToolStep = (
  actionDescription: string,
  actionCategory?: ToolCallActionCategory
): AiThinkingStep => ({
  icon:
    (actionCategory && ACTION_CATEGORY_ICON[actionCategory]) ||
    DEFAULT_STEP_ICON,
  label: actionDescription,
});

export const getPlannedStep = (i18nLocale: I18nLocale): AiThinkingStep => ({
  icon: PLAN_STEP_ICON,
  label: t(i18nLocale, 'assistant:thinkingSteps.planning', 'Planning'),
});

export const buildToolStepsByExchangeId = (
  messages: LoadedChat['messages']
): Record<string, AiThinkingStep[]> =>
  mapValues(
    groupBy(messages.filter(isToolCallMessage), 'exchangeId'),
    toolCalls =>
      toolCalls.map(({ actionDescription, actionCategory }) =>
        getToolStep(actionDescription, actionCategory)
      )
  );
